import React from 'react';
import { Invoice } from '../../models/InvoiceModel';
import moment from 'moment';
import { View, Text, TouchableOpacity } from 'react-native';
import { Badge, CheckBox } from 'react-native-elements';
import { numberFormat } from '../../util/Math';
import { CommonColor, StateColor } from '../../constants/Colors';
import { InvoiceItemStyles } from '../styles/invoiceStyle';

type InvoiceListItemProps = {
  item: Invoice;
  isChecked: boolean;
  onCheck?: (id: string) => void;
  onPress?: (item: Invoice) => void;
  loginUserOrgIds?: Array<number>;
  loginUserId?: number;
};

/**
 * 請求リストアイテム
 */
const InvoiceListItem = React.forwardRef((props: InvoiceListItemProps, ref) => {
  /**props */
  const { item, isChecked, onCheck, onPress, loginUserOrgIds } = props;

  /** チェックボックスの表示条件 **/

  // 表示条件1
  //// 受領権限の有無
  const hasPermission = props.item.own;

  // 表示条件2-1
  //// ログインユーザーの所属組織（loginUserOrgIds）にリスト請求元（itemFromOrg）が含まれているかどうか
  const isOrgMatched = props.loginUserOrgIds?.includes(props.item.from_org);
  // 表示条件2-2
  //// リストアイテムを作成したユーザID
  const itemCreatedUser = props.item.user_id;
  //// ログインユーザのIDがリストアイテムを作成したユーザIDと一致するかどうか
  const isUserIdMatched = itemCreatedUser === props.loginUserId;

  // 判定：チェックボックスの表示条件
  const ifShowCheckbox = hasPermission && (isOrgMatched || isUserIdMatched === true);

  //リストクリック時
  const onHandlePress = () => {
    if (props.onPress) {
      props.onPress(props.item);
    }
  };

  //チェックボックスクリック時
  const onHandlePressCheckBox = () => {
    if (props.onCheck === undefined) {
      return;
    }
    props.onCheck(props.item.id.toString());
  };

  return (
    <TouchableOpacity
      activeOpacity={1}
      style={[
        InvoiceItemStyles.styles.container,
        props.item.teiban_id > 0 && InvoiceItemStyles.styles.backgroundColor,
      ]}
      onPress={onHandlePress}
    >
      <View style={InvoiceItemStyles.styles.checkBoxContainer}>
        {/* No156 チェックボックスの表示条件を変更（受領権限ありのみ→受領権限あり＋記述者と同じ所属かどうか） */}
        {ifShowCheckbox && (
          <CheckBox
            containerStyle={{
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
            wrapperStyle={{
              margin: 0,
            }}
            checked={props.isChecked}
            checkedColor={CommonColor.Normal.Red}
            onPress={onHandlePressCheckBox}
          />
        )}
      </View>
      <View style={InvoiceItemStyles.styles.stateContainer}>
        {props.item.draft != 1 && (
          <View
            style={[
              InvoiceItemStyles.styles.stateBadge,
              { backgroundColor: StateColor[props.item.state] },
            ]}
          >
            <Text style={InvoiceItemStyles.styles.stateText}>{props.item.state_label}</Text>
          </View>
        )}
        {props.item.draft == 1 && (
          <View style={InvoiceItemStyles.styles.stateBadge}>
            <Text style={InvoiceItemStyles.styles.stateText}>下書き</Text>
          </View>
        )}
        {props.item.commented > 0 && (
          <Text style={InvoiceItemStyles.styles.commentText}>コメント済</Text>
        )}
      </View>
      <View style={InvoiceItemStyles.styles.contentContainer}>
        <View style={InvoiceItemStyles.styles.dateRow}>
          <Text style={InvoiceItemStyles.styles.dateText}>
            {moment(props.item.billing_date).format('MM/DD')}
          </Text>
          <View style={[InvoiceItemStyles.styles.orgNameContainer]}>
            <Text
              style={InvoiceItemStyles.styles.orgNameText}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {props.item.to_org_obj.name}
            </Text>
          </View>
          <View style={InvoiceItemStyles.styles.workTypeContainer}>
            <Text
              style={
                props.item.work_type_small == null
                  ? InvoiceItemStyles.styles.workTypeTextUnconfined
                  : InvoiceItemStyles.styles.workTypeText
              }
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {props.item.work_type_small?.name ?? '未選択'}
            </Text>
          </View>
        </View>
        <View style={[InvoiceItemStyles.styles.workRow]}>
          {props.item.teiban_id > 0 && (
            <View style={InvoiceItemStyles.styles.teibanBadge}>
              <Text style={InvoiceItemStyles.styles.teibanText}>定番</Text>
            </View>
          )}
          <Text
            style={
              props.item.work
                ? InvoiceItemStyles.styles.workText
                : InvoiceItemStyles.styles.workTextUnconfined
            }
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {props.item.work ?? '未設定'}
          </Text>
        </View>
        <View style={InvoiceItemStyles.styles.amountRow}>
          <Text
            style={[
              InvoiceItemStyles.styles.amountText,
              { color: props.item.state == 1 ? '#ff0000' : '#ff8c00' },
            ]}
          >
            {numberFormat(Number(props.item.total))}
          </Text>

          <Text style={InvoiceItemStyles.styles.fromOrgText} ellipsizeMode="tail" numberOfLines={1}>
            {'　請求元：'}
            <Text style={InvoiceItemStyles.styles.fromOrgNameText}>
              {props.item.from_org_obj.name}
            </Text>
          </Text>
          <Text
            style={
              props.item.work_type?.name == null
                ? InvoiceItemStyles.styles.workTypeNameTextUnconfined
                : InvoiceItemStyles.styles.workTypeNameText
            }
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {' 【'}
            {props.item.work_type?.name ?? '未設定'}
            {'】'}
          </Text>
        </View>
      </View>
      <View style={InvoiceItemStyles.styles.rightContainer}>
        {props.item.unread > 0 && <Badge value={props.item.unread} status="error" />}
        <Text style={InvoiceItemStyles.styles.arrowText}>{'>'}</Text>
      </View>
    </TouchableOpacity>
  );
});

export default InvoiceListItem;
